import { useEffect, useRef, useState } from "react";
import "../vistas/css/Pruebas.css";
import ConexionSockets from './conexionSockets.js';
import Constantes from "../constantes";

function VentanaFlotante({ id, nombre, color, z, onClose, onFocus }) {
  const boxRef = useRef(null);
  const ref_interna = useRef(null);

  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  const startX = Math.random() * (screenWidth - 240);
  const startY = Math.random() * (screenHeight - 180);

  const coords = useRef({
    startX: 0,
    startY: 0,
    lastX: startX,
    lastY: startY,
  });

  const isClicked = useRef(false);
  const [pos, setPos] = useState({ x: startX, y: startY });
  const posRef = useRef({ x: startX, y: startY });

  const [showReportModal, setShowReportModal] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");

  // Drag
  useEffect(() => {
    if (!boxRef.current) return;
    const box = boxRef.current;

    const onMouseDown = (e) => {
      if (ref_interna.current && ref_interna.current.contains(e.target)) return;

      isClicked.current = true;
      coords.current.startX = e.clientX;
      coords.current.startY = e.clientY;
      box.style.cursor = "grabbing";
      onFocus();
    };

    const onTouchStart = (e) => {
      try {
        if (ref_interna.current && ref_interna.current.contains(e.target)) return;

        isClicked.current = true;
        coords.current.startX = e.touches[0].clientX;
        coords.current.startY = e.touches[0].clientY;
        onFocus();
      } catch (err) {
        console.error("Error en onTouchStart:", err);
      }
    };

    const onMouseUp = () => {
      isClicked.current = false;
      posRef.current = { ...pos };
      box.style.cursor = "grab";
    };

    const onTouchEnd = () => {
      isClicked.current = false;
      posRef.current = { ...pos };
    };

    const onMouseMove = (e) => {
      if (!isClicked.current) return;

      const rawNextX = e.clientX - coords.current.startX + coords.current.lastX;
      const rawNextY = e.clientY - coords.current.startY + coords.current.lastY;

      const maxX = window.innerWidth - box.offsetWidth;
      const maxY = window.innerHeight - box.offsetHeight;

      const nextX = Math.max(0, Math.min(rawNextX, maxX));
      const nextY = Math.max(0, Math.min(rawNextY, maxY));

      setPos({ x: nextX, y: nextY });
      posRef.current = { x: nextX, y: nextY };
    };

    const onTouchMove = (e) => {
      try {
        if (!isClicked.current) return;

        const rawNextX = e.touches[0].clientX - coords.current.startX + coords.current.lastX;
        const rawNextY = e.touches[0].clientY - coords.current.startY + coords.current.lastY;

        const maxX = window.innerWidth - box.offsetWidth;
        const maxY = window.innerHeight - box.offsetHeight;

        const nextX = Math.max(0, Math.min(rawNextX, maxX));
        const nextY = Math.max(0, Math.min(rawNextY, maxY));

        setPos({ x: nextX, y: nextY });
        posRef.current = { x: nextX, y: nextY };
      } catch (err) {
        console.error("Error en onTouchMove:", err);
      }
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    document.addEventListener("touchmove", onTouchMove, { passive: false });
    document.addEventListener("touchend", onTouchEnd);
    box.addEventListener("mousedown", onMouseDown);
    box.addEventListener("touchstart", onTouchStart, { passive: false });

    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("touchmove", onTouchMove);
      document.removeEventListener("touchend", onTouchEnd);
      box.removeEventListener("mousedown", onMouseDown);
      box.removeEventListener("touchstart", onTouchStart);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Enviar incidencia
  const enviarIncidencia = async () => {
    if (!descripcion.trim()) {
      setMensaje("Debes escribir una descripción");
      return;
    }

    setLoading(true);
    setMensaje("");

    try {

      const res = await fetch( Constantes.RUTA_API +"/incidencias/createIncidencia", {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          usuario_denunciado: id,
          descripcion
        })
      });

      const data = await res.json();

      if (!data.error) {
        setMensaje("Incidencia enviada correctamente");
        setDescripcion("");
        setTimeout(() => setShowReportModal(false), 1500);
      } else {
        setMensaje("Error al enviar la incidencia");
      }
    } catch (err) {
      setMensaje("Error de conexión con el servidor");
    }

    setLoading(false);
  };

  return (
    <>
      {/* Ventana flotante */}
      <div
        ref={boxRef}
        style={{
          position: "fixed",
          left: `${pos.x}px`,
          top: `${pos.y}px`,
          zIndex: z,
          background: color,
          border: "1px solid #777",
          borderRadius: "8px",
          width: "300px",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "5px", gap: "8px" }}>
          <strong style={{ flex: "1 1 auto", minWidth: 0, wordBreak: "break-word", overflowWrap: "break-word" }}>
            Chat con {nombre}
          </strong>

          <button
            style={{ background: "#d9534f", color: "white", borderRadius: "5px", whiteSpace: "nowrap", flex: "0 0 auto" }}
            onClick={(e) => {
              e.stopPropagation();
              setShowReportModal(true);
            }}
          >
            Reportar
          </button>

          <button style={{ flex: "0 0 auto" }} onClick={onClose}>✕</button>
        </div>

        <div ref={ref_interna}>
          <ConexionSockets amigoId={id} />
        </div>
      </div>

      {/* Modal fuera del stacking context */}
      {showReportModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999999,
          }}
        >
          <div
            style={{
              color: "black",
              background: color,
              padding: "20px",
              borderRadius: "8px",
              width: "320px",
            }}
          >
            <h3>Reportar a {nombre}</h3>
            <p style={{
              color: "black"
            }}>¿Estás seguro de que deseas abrir una incidencia?</p>

            <textarea
              placeholder="Describe el motivo de la incidencia..."
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
              style={{ width: "100%", height: "80px", marginTop: "10px" }}
            />

            {mensaje && <p style={{
              color: "black"
            }}>{mensaje}</p>}

            <div style={{ marginTop: "10px", display: "flex", justifyContent: "space-between" }}>
              <button onClick={() => setShowReportModal(false)}>Cancelar</button>
              <button disabled={loading} onClick={enviarIncidencia}>
                {loading ? "Enviando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default VentanaFlotante;
